import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=7277238b&scoped=true"
var script = {}
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=7277238b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7277238b",
  null
  
)

export default component.exports